import { useQuery } from "@apollo/client/react";
import { FC, PropsWithChildren, useEffect } from "react";

import { getFragmentData } from "@/generated/graphql";
import { CurrentUserFragmentDoc, GetCurrentUserDocument } from "@/generated/graphql/graphql";
import { useAuthStore } from "@/stores/authStore";

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const { setCurrentUser, clear } = useAuthStore();

  const { data, error } = useQuery(GetCurrentUserDocument);

  useEffect(() => {
    if (data?.me) {
      const user = getFragmentData(CurrentUserFragmentDoc, data?.me);
      setCurrentUser(user);
    }
  }, [data?.me, setCurrentUser]);

  useEffect(() => {
    if (error && error.networkError && error.networkError && "statusCode" in error.networkError) {
      if (error.networkError.statusCode === 401) {
        clear();
      }
    }
  }, [clear, error]);

  return <>{children}</>;
};
